/*
 * Kadenze.NotificationListItem
 *
 * A notification list item is responsible for displaying an individual notification
 *
*/

export default function(params) {
  var self = this;

  // Mapping from notification target_type to css classes
  self.cssClassMapping = {
    'Assignment'                : 'kf kf-coursework',
    'Announcement'              : 'kf kf-announcements',
    'BookResource'              : 'kf kf-book',
    'Course'                    : 'kf kf-coursework',
    'DownloadResource'          : 'kf kf-download',
    'EmbeddedVideoResource'     : 'kf kf-file-video',
    'FileSubmissionAssignment'  : 'kf kf-file-pdf',
    'Forum'                     : 'kf kf-comments',
    'ForumThread'               : 'kf kf-comments',
    'Lecture'                   : 'kf kf-lecture',
    'LinkAssignment'            : 'kf kf-link',
    'LinkResource'              : 'kf kf-file-link',
    'SoftwareResource'          : 'kf kf-software',
    'Survey'                    : 'kf kf-test',
    'Test'                      : 'kf kf-test',
    'ThreadComment'             : 'kf kf-speech-bubble',
    'Quiz'                      : 'kf kf-quiz',
    'default'                   : 'kf kf-file-pdf'
  };

  // Mapping from notification target_status to css classes
  self.smallIconClassMapping = {
    'completed' : 'kdnze-checkmark-circle-fill',
    'upcoming'  : 'kdnze-clock-fill',
    'overdue'   : 'kdnze-warning',
    'urgent'    : 'kdnze-warning urgent'
  };

  self.data = ko.mapping.fromJS(params);
  self._destroy = ko.observable(false);
  self.recentlyUpdated = ko.observable(!self.data.fresh());

  self.UUID = ko.computed(function() {
    return Kadenze.Util.UUID(300);
  });

  // The large icon to the left
  self.iconClass = ko.computed(function() {
    return self.cssClassMapping[self.data.target_type()] || self.cssClassMapping.default;
  });

  // Small icon to the right of the time text, only displays if there is a
  // target_status property
  self.smallIconClass = ko.computed(function() {
    if(typeof self.data.target_status !== 'undefined') {
      return self.smallIconClassMapping[self.data.target_status()];
    }
  });

  self.date_dayNumber = ko.computed(function() {
    return moment(self.data.date()).format('D');
  });
  self.date_shortMonth = ko.computed(function() {
    return moment(self.data.date()).format('MMM');
  });
  self.date_shortYear = ko.computed(function() {
    return moment(self.data.date()).format('YY');
  });

  // Class when the item is marked as viewed
  self.viewedClass = ko.computed(function() {
    return self.data.viewed() ? 'notification notification--read' : 'notification';
  });

  // Url for when the item is clicked
  self.targetUrl = ko.computed(function() {
    return Kadenze.Util.insertURLParam(self.data.target_url(), 'viewed_notification', self.data.id());
  });

  self.dateAsText = ko.computed(function() {
    return (typeof self.data.date == 'function') && moment(self.data.date()).fromNow() || '';
  });

  self.summaryText = ko.computed(function() {
    if (self.data.target_date) {
      return self.data.summary().supplant({target_date: self.data.target_date()});
    } else {
      return self.data.summary();
    }
  });

  // Returns if the item is in view or not
  self.isInView = function() {
    var $node = $('#' + self.UUID()),
      $parentObject = $node.parents('.notification-center__content');

    return ($parentObject.scrollTop() + $parentObject.height()) > ($node.offset().top + 20);
  };

  self.truncatedTitle = function() {
    return s.truncate(self.data.title(), 58);
  };

  // when the item is clicked window.location is sent to its' target
  self.navigateToTarget = function() {
    window.location.href = self.targetUrl();
  };

  return self;
}

